/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */
import { React } from 'react';
import '../../css/layout/Footer.css'

export default function Footer(props) {
    const now = new Date();
    const year = now.getFullYear();

    return  (
        <>
            <div className='footer'>
                <p>
                    {props.name} - version {props.version} - &#169; {props.company} {year}
                </p>
            </div>
        </>
    )
};